import DOMPurify from "dompurify";

// Convert legacy plain-paragraph content (with ![caption](url) image tokens) into editor HTML
export function blocksToHtml(content) {
  return (content || [])
    .map((p) => {
      const m = /^!\[([^\]]*)\]\(([^)\s]+)\)\s*$/.exec((p || "").trim());
      if (m) return `<img src="${m[2]}" alt="${m[1].replace(/"/g, "&quot;")}">`;
      const esc = (p || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return `<p>${esc}</p>`;
    })
    .join("");
}

// Prepare editor HTML for public rendering: wrap images in figures with captions, then sanitize
export function renderEssayHtml(html) {
  const withFigures = (html || "").replace(/<img([^>]*?)>/g, (match, attrs) => {
    const alt = /alt="([^"]*)"/.exec(attrs)?.[1] || "";
    const caption = alt ? `<figcaption>${alt}</figcaption>` : "";
    return `<figure><img${attrs}>${caption}</figure>`;
  });
  return DOMPurify.sanitize(withFigures);
}
